<template>
  <div class="formways-component formways-htmlelement" v-if="!ctx.hidden" :class="ctx.customClass">
    <component
      :is="ctx.tag"
      :key="ctx.key"
      v-html="ctx.content"
      :class="ctx.className"
      v-bind="processedAttrs"
    >
    </component>
  </div>
</template>

<script>
import SimpleComponentMixin from '../../mixins/SimpleComponentMixin';
import defaultSchema from './defaultSchema';

export default {
  name: 'htmlelement',
  mixins: [SimpleComponentMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  },
  computed: {
    processedAttrs() {
      const pattrs = {};
      this.ctx.attrs.forEach(item => {
        if (item.attr) {
          pattrs[item.attr] = item.value;
        }
      });
      return pattrs;
    }
  }
};
</script>
